// import './js/dark-theme'; // Disabled dark theme swithing
import SimpleLightbox from 'simplelightbox';

// Lightbox Projects page only
const isProjectsPage = document.body.classList.contains('single-projects');

isProjectsPage &&
  window.addEventListener(
    'load',
    () => {
      const images = document.querySelectorAll('img.js-lazy');
      const figureImages = document.querySelectorAll('figure.js-lazy img');
      const allImages = [...images, ...figureImages];
      console.log(allImages);

      // let gallery = new SimpleLightbox('img.js-lazy');
      let gallery = new SimpleLightbox(allImages, {
        sourceAttr: 'data-src',
        overlayOpacity: 1,
        captionSelector: document.querySelector('h1.entry-title'),
      });

      // gallery.on('show.simplelightbox', function () {
      //   // Do something…
      //   console.log('show lightbox');
      // });
    },
    { passive: true }
  );

// LAZY LOADING IMAGES
// LAZY LOAD WITH INTERSECTION OBSERVER 01 - NO OFFSET
class lazyCheck {
  static get SUPPORTS_INTERSECTION_OBSERVER() {
    return 'IntersectionObserver' in window;
  }
}

const lazyLoad = (target) => {
  const io = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const src = img.getAttribute('data-src');
          const srcset = img.getAttribute('data-srcset');

          img.setAttribute('srcset', srcset);
          img.setAttribute('src', src);
          img.classList.add('fadeIn');

          observer.disconnect();
        }
      });
    },
    { rootMargin: '500px 0px 500px 0px' }
  );

  io.observe(target);
};

window.addEventListener(
  'load',
  (event) => {
    const targets = document.querySelectorAll('img.js-lazy, .js-lazy img');
    if (!lazyCheck.SUPPORTS_INTERSECTION_OBSERVER && pageIsLoaded && targets) {
      targets.forEach((target) => {
        let src = target.getAttribute('data-src');
        let srcset = target.getAttribute('data-srcset');

        target.setAttribute('srcset', srcset);
        target.setAttribute('src', src);
        target.style.height = 'auto';
        target.classList.add('fadeIn');
      });
    } else {
      targets.forEach(lazyLoad);
    }
  },
  { passive: true }
);

// FIXED HEADER ON SCROLL DOWN
const header = document.querySelector('.master-head__container');
const isHomepage = document.querySelector('body').classList.contains('home');
let lastScroll = 0;

//
// THROTTLE FUNCTION VERSION 1
//
// const throttle = (func, time = 100) => {
//   let lastTime = 0;
//   return () => {
//     const now = new Date();
//     if (now - lastTime >= time) {
//       func();
//       time = now;
//     }
//   };
// };
// end:: THROTTLE FUNCTION VERSION 1

//
// THROTTLE FUNCTION VERSION 2
// from: webdesign.tutsplus.com -> https://webdesign.tutsplus.com/tutorials/javascript-debounce-and-throttle--cms-36783 (there is also a nice Debounce function there)
//
//initialize throttlePause variable outside throttle function
let throttlePause = false;
// console.log('throttlePause ', !!throttlePause);

const throttle = (callback, time = 250) => {
  //don't run the function if throttlePause is true
  if (throttlePause) return;

  //set throttlePause to true after the if condition. This allows the function to be run once
  throttlePause = true;

  //setTimeout runs the callback within the specified time
  setTimeout(() => {
    callback();

    //throttlePause is set to false once the function has been called, allowing the throttle function to loop
    throttlePause = false;
  }, time);
};
// end:: THROTTLE FUNCTION VERSION 2

const validateHeader = () => {
  const windowY = window.scrollY;
  const windowH = window.innerHeight;
  const header = document.querySelector('.master-head__container');
  const body = document.querySelector('body');
  const headerHeight = header.clientHeight;

  // console.log('headerHeight');
  // console.log(headerHeight);
  // console.log(windowY);
  // if (windowY > windowH) {
  if (windowY > headerHeight) {
    // We passed the first section, set a toggable class
    header.classList.add('is-fixed');
    body.style.paddingTop = headerHeight + 'px';
    // Determine is we ready to animate
    // if (windowY > windowH + 40) {
    if (windowY > windowH) {
      header.classList.add('can-animate');
      if (windowY < lastScroll) {
        // Determine if we scrolling up
        header.classList.add('scroll-up');
      } else {
        header.classList.remove('scroll-up');
      }
    } else {
      header.classList.remove('scroll-up');
    }
  } else {
    header.classList.remove('is-fixed', 'can-animate');
    body.style.paddingTop = 0;
  }
  lastScroll = windowY;
};

// Don't fix header on homepage due to the page height and content, it is not needed
!isHomepage &&
  window.addEventListener(
    'scroll',
    () => {
      throttle(validateHeader, 250);
    },
    { passive: true }
  );

// Add aria-label to the project links on the home page. It's not possible to do it when building links
isHomepage &&
  window.addEventListener(
    'load',
    () => {
      const projects = document.querySelectorAll('.entry-content figure');
      projects.forEach((project) => {
        const link = project.getElementsByTagName('a')[0];
        const image = project.getElementsByTagName('img')[0];
        const altText = image.getAttribute('alt');

        link.setAttribute('aria-label', altText);
      });
    },
    { passive: true }
  );

//
// Add .active class to menu item based on current page
//
!isHomepage &&
  window.addEventListener(
    'load',
    () => {
      const menuItems = document.querySelectorAll('li.menu-item a');

      if (
        document
          .getElementsByTagName('body')[0]
          .classList.contains('single-post')
      ) {
        menuItems.forEach((item) => {
          item.textContent === 'Blog' && item.classList.add('active');
        });
        return;
      }

      menuItems.forEach((item) => {
        const path = window.location.pathname;
        const href = item
          .getAttribute('href')
          .replaceAll('https://', '')
          .replaceAll('http://', '')
          .replaceAll('localhost:8002', '')
          .replaceAll('antonio-rodriguez.com', '')
          .replaceAll('staging.antonio-rodriguez.com', '');
        const exactMatch = path === href; // URL is the same as anchor. Useful when your path can contain the href of multiple links
        const closeMatch = href !== '/' && path.indexOf(href) !== -1; // URL contains anchor.
        // Useful when you don't know if query strings and other crap will be appended/prepended to your links

        if (closeMatch /* or exactMatch depending on your preference*/) {
          item.classList.add('active');
        }
      });
    },
    { passive: true }
  );
